import React from 'react'
import PropTypes from 'prop-types'

import Typography from 'material-ui/Typography'
import { withStyles } from 'material-ui/styles'
import TextField from 'material-ui/TextField'

import Toolbar from 'material-ui/Toolbar'

import IconButton from 'material-ui/IconButton'
import {Close as CloseIcon} from 'material-ui-icons'

import * as f from '../etc/formatters'
import {task_t} from '../etc/common-props'
import classNames from '../etc/class-names'
import moment from 'moment'

import {FormControlLabel} from 'material-ui/Form'
import Checkbox from 'material-ui/Checkbox'

let styles = theme => ({
  root: {
    width: '100%'
  },
  toolbar: {
    width: '100%',    
    display: 'flex'
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  flex: {
    flex: 1
  },
  textField : {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit
  },
  full_line: {
    width: '100%',
    display: 'flex'  
  },
  large: {
    width: 400
  },
  medium: {
    width: 200
  },
  small: {
    width: 120
  }
})


let TaskInfo = ({classes, object, onRequestClose}) => (
  <div className={classNames(classes.root)}>
    <Toolbar disableGutters className={classes.toolbar}>
      <Typography type="title" component="h2" className={classes.flex}>
        Task Information
      </Typography>
      <IconButton color="primary" aria-label="Close" onClick={onRequestClose}>
        <CloseIcon />
      </IconButton>
    </Toolbar>
    <div className={classes.container}>
      <div className={classes.full_line}>
        <TextField
          id="name"
          label="Name"
          className={classNames(classes.textField, classes.flex)}
          value={object.name}
          margin="normal"
          InputProps={{disableUnderline: true}}
        />
        <TextField
          id="wbs"
          label="WBS"
          className={classNames(classes.textField, classes.small)}
          value={object.wbs}
          margin="normal"
          InputProps={{disableUnderline: true}}
        />
      </div>
      <div>
        <TextField
          id="start_date"
          label="Start Date"
          className={classNames(classes.textField, classes.small)}
          value={moment(object.start).format('YYYY-MM-DD')}
          margin="normal"
          InputProps={{disableUnderline: true}}
        />
        <TextField
          id="start_time"
          label="Start Time"
          className={classNames(classes.textField, classes.small)}
          value={moment(object.start).format('hh:mm')}
          margin="normal"
          type="time"
          InputProps={{disableUnderline: true}}
        />
      </div>
      <div>
        <TextField
          id="finish_date"
          label="Finish Date"
          className={classNames(classes.textField, classes.small)}
          value={moment(object.finish).format('YYYY-MM-DD')}
          margin="normal"
          InputProps={{disableUnderline: true}}
        />
        <TextField
          id="finish_time"
          label="Finish Time"
          className={classNames(classes.textField, classes.small)}
          value={moment(object.finish).format('hh:mm')}
          margin="normal"
          type="time"
          InputProps={{disableUnderline: true}}
        />
      </div>
      <TextField
        id="duration"
        label="Duration"
        className={classNames(classes.textField, classes.small)}
        value={f.duration(object.duration)}
        margin="normal"
        type="number"
        InputProps={{disableUnderline: true}}
      />
      <div>
        <TextField
          id="status"
          label="Status"
          className={classNames(classes.textField, classes.large)}
          value={f.taskStatus(object.status)}
          margin="normal"
          InputProps={{disableUnderline: true}}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={object.critical}
              value="critical"
            />
          }
          label="Critical"
        />
      </div>
      <div>
        <TextField
          id="fixed_cost"
          label="Fixed Cost"
          className={classNames(classes.textField, classes.medium)}
          value={f.currency(object.fixed_cost)}
          margin="normal"
          InputProps={{disableUnderline: true}}
        />
        <TextField
          id="resource_cost"
          label="Resource Cost"
          className={classNames(classes.textField, classes.medium)}
          value={f.currency(object.resource_cost)}
          margin="normal"
          InputProps={{disableUnderline: true}}
        />
        <TextField
          id="total_cost"
          label="Total Cost"
          className={classNames(classes.textField, classes.medium)}
          value={f.currency(object.total_cost)}
          margin="normal"        
          InputProps={{disableUnderline: true}}
        />
      </div>
    </div>
  </div>
)

TaskInfo.propTypes = {
  classes: PropTypes.object.isRequired,
  task_data: task_t
}


export default withStyles(styles)(TaskInfo)




// WEBPACK FOOTER //
// ./src/components/TaskInfo.js